import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faFileImport } from '@fortawesome/free-solid-svg-icons';
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';

@Component({
  selector: 'file-upload',
  templateUrl: './file-upload.component.html'
})
export class FileUploadComponent {

  @Input() allowMultiple: boolean = false;
  @Input() dropZoneLabel: string = "";
  @Input() buttonLabel: string = "Browse files";
  @Input() acceptedFileTypes: string[] = [];

  @Output() importFilesEvent = new EventEmitter<File[]>();

  public faFileImport = faFileImport;
  public importFiles: File[] = [];
  public errorMessage: string = "";

  constructor() { }

  public get grammer(): string {
    var vowels = ("aeiouAEIOU"); 
    return vowels.indexOf(this.dropZoneLabel[0]) !== -1 ? "an" : "a";
  }

  public dropped(files: NgxFileDropEntry[]): void {

    this.errorMessage = "";
    this.importFiles = [];

    if(!this.allowMultiple && files.length > 1) {
      throw Error("Cannot upload multiple files.");
    }

    for (let droppedFile of files) {
    
      const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;

      if(this.isValidFileType(fileEntry) && fileEntry.isFile) {
        fileEntry.file((file: File) => {
          this.importFiles.push(file);
        });
      }
      else {
        this.errorMessage = `File ${fileEntry.name} is not a valid file type.`;
      }
    }

    //emit files back to parent component
    this.importFilesEvent.emit(this.importFiles);
  }

  //validates a file against the accepted file types array
  public isValidFileType(file: FileSystemFileEntry): boolean {
    
    let isValidFile: boolean = false;

    if(file) {
      if(this.acceptedFileTypes.length > 0) {
        const extensionRegEx = /(?:\.([^.]+))?$/;
        let fileExtension: string = extensionRegEx.exec(file.name)[1];
        
        if(this.acceptedFileTypes.indexOf(fileExtension) >= 0) {
          isValidFile = true;
        }
      }
      else {
        isValidFile = true;
      }
    }

    return isValidFile;
  }
}
